import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getJiraStatusesSlice } from './get';
import { postJiraStatusesSlice } from './post';

export const jiraStatusesReducers = combineReducers({
	get: getJiraStatusesSlice.asyncReducers,
	post: postJiraStatusesSlice.asyncReducers
});

export const jiraStatusesWatchers = combineAllWatchers([
	getJiraStatusesSlice.asyncWatchers,
	postJiraStatusesSlice.asyncWatchers
]);
